import React from 'react';
import { isSalePricingActive, getSaleSharedPerPersonRate } from '../utils/salePricingOverlay';

// Advertise only while the campaign is active and this trip uses a sale ladder.
const SharedSaleBadge = ({ trip, segment }) => {
  const created = new Date(trip?.created_at);
  if (!trip?.created_at || !Number.isFinite(created.getTime()) || !isSalePricingActive()
    || getSaleSharedPerPersonRate(segment, 1, created) == null) return null;
  return <span className="inline-flex rounded-full bg-[#A44432] px-2 py-0.5 text-xs font-bold text-white">Sale fare</span>;
};

export default SharedSaleBadge;
